module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pick.title))]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('span', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.pick.sport.sport))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.pick.date))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.pick.content)
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.pick.pick))]), _vm._v("\n         \n  "), _c('b', [_vm._v(_vm._s(_vm.pick.side))]), _vm._v("\n         \n  "), _c('b', [_vm._v(_vm._s(_vm.pick.price))]), _vm._v("\n         \n  "), _c('b', [_vm._v(_vm._s(_vm.pick.units))]), _vm._v("\n   \n  "), _c('b', [_vm._v(_vm._s(_vm.pick.units > 1 ? 'units' : 'unit'))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d1f58ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pick.vue
// module id = 511
// module chunks = 1